<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('VIREMENT_ETABLISSEMENT')">
        <slot name="section-virement-etablissement">
          <section-virement-etablissement ref="VIREMENT_ETABLISSEMENT"
                                          id="VIREMENT_ETABLISSEMENT"
                                          :extended="isExtended('VIREMENT_ETABLISSEMENT')"
                                          :showButton="true"
                                          :autoSave="true"
                                          :readOnly="readOnly"
                                          :moduleId="moduleId"
                                          :searchText="searchText"
                                          :ressourceHeader="ressource"
                                          :fiche="fiche"
                                          :support=selectedSupport
                                          :route="route"
                                          :attribut="attribut"
                                          @extended="setExtended"
                                          @fullscreen="setFullscreen"
                                          @status="updateStatus"
                                          @updated="supportUpdated"
                                          @selectItem = "selectItem">
          </section-virement-etablissement>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Support from '@/extend/classes/Support';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionVirementEtablissement from '@/custom/sections/SectionVirementEtablissement.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionVirementEtablissement,
    FicheHeader,
  },

  props: {
    support: {
      type: Object as PropType<Support>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.VIREMENT_ETABLISSEMENT,
      sections: [
        'VIREMENT_ETABLISSEMENT',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_VIREMENT_ETABLISSEMENT);
    },

    selectedSupport (): Support {
      return this.support
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    supportUpdated (support: Support) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.support || this.support.id < 0) && value == 'VIREMENT_ETABLISSEMENT') {
        this.setExtended(new Extended('VIREMENT_ETABLISSEMENT', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
